import { render, staticRenderFns } from "./InputfieldDescription.vue?vue&type=template&id=3e4b4547&scoped=true&"
import script from "./InputfieldDescription.vue?vue&type=script&lang=js&"
export * from "./InputfieldDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4b4547",
  null
  
)

export default component.exports